import styled from 'styled-components';
import breakpointsMinWidth from '../../../../../styling/breakpointsMinWidth';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  color: #1f1f1f;
`;
export const Header = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-bottom: 14px;
  @media ${breakpointsMinWidth.tabletLg} {
    margin-bottom: 14px;
  }
  @media ${breakpointsMinWidth.desktopMd} {
    margin-bottom: 16px;
  }
`;
export const HeadingText = styled.div`
  font-size: 20px;
  line-height: 22px;
  margin-bottom: 16px;
  text-align: left;
  @media ${breakpointsMinWidth.tabletLg} {
    font-size: 16px;
    line-height: 24px;
    margin-bottom: 18px;
  }
  @media ${breakpointsMinWidth.desktopMd} {
    font-size: 20px;
    line-height: 26px;
    margin-bottom: 20px;
  }
`;
export const SubHeadingText = styled.div`
  font-size: 14px;
  line-height: 16px;
  text-align: left;

  @media ${breakpointsMinWidth.tabletLg} {
    line-height: 16px;
  }
  @media ${breakpointsMinWidth.desktopMd} {
    line-height: 20px;
  }
`;
